export const isVideoUrl = (url?: string | null): boolean => {
  if (!url) return false
  const clean = url.split('?')[0].toLowerCase()

  if (clean.endsWith('.mp4') || clean.endsWith('.mov') || clean.endsWith('.webm') || clean.endsWith('.m4v') || clean.endsWith('.avi')) {
    return true
  }

  if (clean.includes('/video') || clean.includes('video_') || clean.includes('videoplayback') || clean.includes('hvideo') || clean.includes('video.')) {
    return true
  }

  return false
}
